import script from "./FrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"
export * from "./FrequenciaEncontro.vue?vue&type=script&setup=true&lang=js"

import "./FrequenciaEncontro.vue?vue&type=style&index=0&id=867a3244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-867a3244"]])

export default __exports__